import styled from "styled-components";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";

export const ModelName = styled.h2`
    position: relative;
    margin: 0;
    font-size: 4.4rem;
    letter-spacing: -0.03px;
    text-align: start;
    text-transform: none;
    color: ${theme.colors.primaryBlack};
`;

export const ImageWrapperMobile = styled(Flex.Col)`
    display: flex;
    align-items: center;
    padding-left: 0;
    padding-right: 0;

    img {
        margin: 0 auto;
    }

    @media ${getBreakpoint("up", "md")} {
        display: none;
    }
`;

export const ImageWrapper = styled(Flex.Col)`
    display: none;
    @media ${getBreakpoint("up", "md")} {
        display: flex;
        align-items: center;
    }
`;

export const CTAWrapper = styled(Flex.Col)`
    display: flex;
    position: relative;
    align-items: flex-end;
    justify-content: flex-end;
`;

export const FloatingArea = styled.div`
    display: none;
    order: 1;

    @media ${getBreakpoint("only", "md")} {
        position: absolute;
        top: -35px;
        right: 0;
    }
    @media ${getBreakpoint("up", "md")} {
        display: block;
        margin-top: 38px;
    }
    @media ${getBreakpoint("up", "lg")} {
        order: 2;
        margin-top: 0;
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("only", "md")} {
            left: 0;
            right: auto;
        }
    }
`;

export const GradeListTitle = styled.h2`
    margin-top: 28px;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
    line-height: 2rem;
    text-align: start;
    text-transform: uppercase;
`;

export const GradeEquipmentInfo = styled(Flex.Col)`
    ${Button.ButtonTertiary} > .btn-text {
        padding: 0 !important;
    }
`;

export const GradeList = styled.ul`
    display: block;
    margin: ${theme.space[2]}px 0;
    padding: 0;
    line-height: 3rem;

    li,
    span:not(:empty) {
        font-size: 1.3rem;
        line-height: 2rem;
        color: ${theme.colors.grey7};
    }

    li {
        display: list-item;
        position: relative;
        margin-bottom: ${theme.space[1]}px;
        padding-left: 20px;
        list-style-type: none;
        &::before {
            position: absolute;
            top: -1px;
            left: 0;
            font-size: 3rem;
            line-height: 2rem;
            color: ${theme.colors.primaryRed};
            content: "·";
            vertical-align: sub;
        }
    }

    /* Update layout colorTheme bz4x */
    .bz & {
        li::before {
            color: ${theme.colors.bz4x};
        }
    }

    html[dir="rtl"] & {
        li {
            padding-left: 0;
            padding-right: 20px;
            &::before {
                left: auto;
                right: 0;
            }
        }
    }
`;

export const FeatureEquipment = styled.div`
    display: none;
    @media ${getBreakpoint("up", "md")} {
        display: block;
    }
`;
